import { makeStyles } from "@material-ui/core/styles";

const useTooltipContentStyles = makeStyles((theme) => ({
  content: {
    padding: theme.spacing(1, 3),
    paddingTop: 0,
    backgroundColor: theme.palette.background.paper,
    boxSizing: "border-box",
    width: "400px",
  },
  titleContainer: {
    paddingBottom: theme.spacing(2),
  },
  contentContainer: {
    paddingBottom: theme.spacing(1.5),
  },
  dateAndTitle: {
    lineHeight: 1.1,
  },
  text: {
    ...theme.typography.body2,
    fontWeight: theme.typography.fontWeightBold,
    display: "inline-block",
    fontSize: "14px",
  },
  title: {
    ...theme.typography.h6,
    fontWeight: theme.typography.fontWeightBold,
    fontSize: "26px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "normal",
  },
  time: {
    ...theme.typography.body2,
    fontWeight: theme.typography.fontWeightRegular,
    display: "inline-block",
    fontSize: "14px",
  },
  icon: {
    verticalAlign: "middle",
    margin: "0 5px 0 0",
  },
  contentItemIcon: {
    textAlign: "center",
  },
  textCenter: {
    textAlign: "center",
  },
  tag: {
    width: "90px",
    height: "25px",
    textAlign: "center",
    borderRadius: "4px",
    fontSize: "12px",
    fontWeight: theme.typography.fontWeightRegular,
    backgroundColor: "rgba(67, 138, 254, 0.3)",
    paddingTop: "4px",
    marginTop: "8px",
  },
  divider: {
    margin: "12px 0px",
    background: "rgba(0, 0, 0, 1)",
  },
  rescheduleButton: {
    color: theme.palette.info.main,
    paddingLeft: "4px",
  },
  rescheduleButtonIcon: {
    "& > span > span > svg": {
      marginLeft: "0px",
    },
  },
}));

const useTooltipHeaderStyles = makeStyles((theme) => ({
  head: {
    "& button": {
      color: "rgba(0, 0, 0, 1)",
    },
    "& hr": {
      backgroundColor: "rgba(0, 0, 0, 1)",
      height: "15px",
      marginTop: "15px",
    }
  },
}));

export { useTooltipContentStyles, useTooltipHeaderStyles };
